import Vue from "vue";
import Vuex from "vuex";
import user from "@/store/module/user";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    screenWidth:document.documentElement.clientWidth, //螢幕寬度
    navHeight: 0,
  },
  mutations: {},
  actions: {},
  modules: {
    user: user,
  },
});
